module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBoldItalic.d12f79d8.woff";